<template>
  <div class="btn fRow jCenter aCenter transition-fast"
    :title="label"
    v-ripple="'var(--normalText15)'"
    v-bind:class="{
      flat: flat,
      fab: fab,
      mini: mini,
      invert: invert,
      ltr: !rtl,
      wide: wide,
      disable: disable,
      fav: fav}"
    v-bind:style="{backgroundColor: `${bc}`}">
    <i class="material-icons-round">{{ic}}</i>
    <label>{{label}}</label>
    <div class="badge" v-if="badge >= 0">{{badge}}</div>
  </div>
</template>

<script>
export default {
  props: ['label',
    'disable',
    'ic',
    'fab',
    'mini',
    'flat',
    'mode',
    'invert',
    'wide',
    'rtl',
    'badge',
    'fav'],
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
    mainClass() {
      let className = '';
      if (this.flat) {
        className += 'flat ';
      }
      if (this.fab) {
        className += 'fab ';
      }
      if (this.mini) {
        className += 'mini ';
      }
      alert(className);
      return className;
    },
    bc() {
      let a = '';
      switch (this.mode) {
        case 'success': {
          a = '#40aa45';
          break;
        }
        case 'error': {
          a = '#be2c00';
          break;
        }
        case 'warn': {
          a = '#cfa122';
          break;
        }
        default: {
          a = '#578dd5';
          break;
        }
      }
      return a;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  border-radius: 16px;
  padding: 8px 16px;
  position: relative;
  background-color: var(--primary);
  cursor: pointer;
  margin: 0 2px;
  opacity: 0.95;
  * {
    pointer-events: none;
    user-select: none;
  }
  i {
    margin-left: 8px;
    color: var(--themeWhite);
  }
  label {
    font-family: iy;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;
    color: var(--themeWhite);
    white-space: nowrap;
  }
  .badge {
    padding: 4px 4px 2px;
    border-radius: 8px;
    font-size: 10px;
    letter-spacing: 0px;
    line-height: 1;
    color: var(--themeWhite);
    background-color: var(--themeRed);
    position: absolute;
    top: 0;
    right: 0;
  }
}

.btn.ltr {
  i {
    margin-left: unset !important;
    margin-right: 8px;
  }
  label {
    font-family: DM !important;
    line-height: 1;
  }
}

.btn.invert {
  i {
    color: var(--shade);
  }
  label {
    color: var(--invertText);
  }
}
.btn.flat {
  background-color: var(--normalText05) !important;
  i, label {
    color: var(--normalText);
  }
}
.btn.fab {
  $fsize: 56px;
  width: $fsize;
  height: $fsize;
  min-width: $fsize;
  min-height: $fsize;
  border-radius: 50%;
  i {
    margin: 0 !important;
  }
  label {
    display: none;
  }
}
.btn.fab.mini {
  $mfsize: 40px;
  width: $mfsize;
  height: $mfsize;
  min-width: $mfsize;
  min-height: $mfsize;
  label {
    display: none;
  }
  i {
    font-size: 24px !important;
  }
}
.btn.fab.fav {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px;
  min-height: 24px;
  padding: 0;
  label {
    display: none;
  }
  i {
    font-size: 16px !important;
  }
}
.btn.fab.mini.wide {
  $mfsize: 40px;
  width: 64px !important;
  height: $mfsize;
  min-width: $mfsize;
  min-height: $mfsize;
  border-radius: 64px !important;
  label {
    display: none;
  }
  i {
    font-size: 24px !important;
  }
}
.btn.mini {
  i {
    font-size: 16px;
  }
  label {
    font-size: 12px;
  }
}
// hovers
.btn:hover {
  filter: brightness(110%);
}
.btn.flat:hover {
  background-color: var(--normalText05) !important;
}
.btn.disable {
  pointer-events: none;
  opacity: 0.5;
}
</style>
